export const sortOrder = {
  valueAscending: 0,
  valueDescending: 1,
  alphabeticallyAtoZ: 2,
  alphabeticallyZtoA: 3,
};
